/*
 * Copyright (C) 2026 to Present Applause App Quality, Inc. All rights reserved.
 */

import { InjectionToken } from '@angular/core';
import { DelightSupportConfig } from './+model/delight-support.model';

export const DELIGHT_SUPPORT_CONFIG = new InjectionToken<DelightSupportConfig>('DelightSupportConfig');
export const DELIGHT_DISPLAY_NAME = new InjectionToken<() => string>('DelightDisplayName');
